module.exports = __webpack_public_path__ + "static/header-5ff6d05aed09dd64f961b28f4e8fede1.jpg";